/* eslint-disable security/detect-object-injection */
/* eslint-disable import/no-unresolved */
// eslint-disable-next-line import/no-unresolved
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import { onChangeIndianCurrency } from "src/helpers/FormDetails";
import { loanDetailsProductWise } from "src/helpers/FormDetails/resources";
import CustomReviewField from "../../../../../shared/CustomReviewField";
import CustomLabel from "../../../../../shared/CustomLabel";

function PlanDetailsReview() {
  const loanDetails = useAppSelector((state) => state.loanDetails);
  const productId = useAppSelector((state) => state.common?.productId)!;
  const planDetailsReviewMefFields = useAppSelector(
    (state) => state.masterdata_reducer?.mefJourneySchema?.planDetails
  );

  return (
    <div>
      <div className="flex justify-between mt-8">
        <div className="text-base font-bold">Plan Details</div>
      </div>
      <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 md:gap-x-28 gap-x-3 mt-6 max-sm:ml-4 ">
        {(loanDetails?.plan?.coverOption || planDetailsReviewMefFields?.coverOption?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planDetailsReviewMefFields?.coverOption?.label}</CustomLabel>
            <CustomReviewField>{loanDetails?.plan?.coverOption || "-"}</CustomReviewField>
          </div>
        )}

        {(loanDetails?.plan?.deathSumInsured ||
          planDetailsReviewMefFields?.deathSumAssured?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planDetailsReviewMefFields?.deathSumAssured?.label}</CustomLabel>
            <CustomReviewField>
              ₹ {onChangeIndianCurrency(loanDetails?.plan?.deathSumInsured || "-")}
            </CustomReviewField>
          </div>
        )}

        {(loanDetails?.plan?.coverTerm || planDetailsReviewMefFields?.coverTerm?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planDetailsReviewMefFields?.coverTerm?.label}</CustomLabel>
            <CustomReviewField>
              {loanDetails?.plan?.coverTerm || "-"} {loanDetailsProductWise[productId]?.term}
            </CustomReviewField>
          </div>
        )}

        {(loanDetails?.plan?.premiumPaymentTerm ||
          planDetailsReviewMefFields?.premiumPaymentTerm?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{planDetailsReviewMefFields?.premiumPaymentTerm?.label}</CustomLabel>
            <CustomReviewField>{loanDetails?.plan?.premiumPaymentTerm || "-"}</CustomReviewField>
          </div>
        )}
      </div>
    </div>
  );
}
export default PlanDetailsReview;
